'use client';

import * as React from 'react';
import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';
import designTokens from '../../styles/design-tokens.json';

function ThemeChrome() {
  const { resolvedTheme } = useTheme();
  React.useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]'
    );
    if (meta) {
      meta.content =
        designTokens.semantic.background.$value[
          resolvedTheme === 'light' ? 'light' : 'dark'
        ];
    }
  }, [resolvedTheme]);
  return null;
}

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <ThemeChrome />
      {children}
    </NextThemesProvider>
  );
}
